<template>
  <div class="back">
    <div class="header">
      <el-row class="tac">
        <el-col :span="1">
          &ensp;
        </el-col>
        <el-col :span="3">
          <img src="../png/qssyLogo.jpg" style="width: 18vh;height:6.5vh;padding-top: 4.2vh;margin-left: -1%"/>
        </el-col>
        <el-col :span="20">
<!--          <h1 style=" ">员工除名曝光台</h1>-->
          <p style="font-size: 5vh;margin-left: -15vh"><b>除名员工曝光台</b></p>
        </el-col>
      </el-row>
<!--      <img src="../png/qssyLogo.jpg" style="width: 160px;height:55px;float: left;margin-left: 13%;  padding-top: 0.8% " @click="handleBack"/>-->
<!--      <h2 style="float: left">青山实业廉洁</h2>-->
<!--      <h1 style="text-align: center">曝光台</h1>-->
    </div>
    <el-row class="tac">
      <el-col :span="1">
        &ensp;
      </el-col>
      <el-col :span="3">
<!--        <h5>自定义颜色</h5>-->
        <el-menu
          :default-active="index"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          @select="handleSelect"
          style="height:81vh;text-align: left">
          <el-menu-item index="1">
            <i class="el-icon-user-solid"></i>
            <span slot="title"><b>员工除名名单</b></span>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-s-order"></i>
            <span slot="title"><b>合作伙伴黑名单</b></span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="3">
        &nbsp;
      </el-col>
      <el-col :span="13">
        <h3 style="float:left;">公示名单</h3>
        <div>
          <el-table
            :data="tableData"
            :height="tableHeight"
            :header-cell-style="{
            background:'#409EFF',color:'#ffffff',border: '1px solid white',size:'25px'}"
            stripe
            border
            style="width: 100%;margin-top: 2%">
            <el-table-column
              align="center"
              type="index"
              label="序号"
              width="80">
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="姓名"
              width="200">
            </el-table-column>
            <el-table-column
              align="center"
              prop="empDepartment"
              label="原任职情况"
              >
            </el-table-column>
            <el-table-column
              align="center"
              prop="dismissTime"
              label="除名日期"
              width="200">
            </el-table-column>
          </el-table>
          <div class="avue-crud__pagination">
            <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="current"
              :page-sizes="[10, 25, 50]"
              :page-size="pageSize"
              :total="total"
              style="float: right;margin-top: 1%"
              background
              layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </div>
        <br><br>
        <el-divider></el-divider>
        <div>
          <h3 style="text-align: left">快捷查询</h3>
          <div style="margin-top: 2%;width: 100%;text-align: left">
            <el-form  ref="form" :rules="rules" :model="form" inline >
              <el-form-item label="姓名" prop="name">
                <el-input
                  type="text"
                  placeholder="姓名"
                  class="ptTxtInput"
                  style="width: 250px"
                  size="middle"
                  v-model="form.name">
                </el-input>
              </el-form-item>
              <el-form-item label="身份证号" prop="idCard" style="margin-left: 3%">
                <el-input
                  type="text"
                  placeholder="身份证号"
                  class="ptTxtInput"
                  style="width: 250px;"
                  size="middle"
                  v-model="form.idCard">
                </el-input>
              </el-form-item>
              <el-button type="primary" plain style="margin-left: 2%" @click="handleSearch">查询</el-button>
            </el-form>
          </div>
          <div v-if="isShow" style="text-align: left;">
            <span>查询结果：</span><span style="color: red">{{ msg }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/api/request'
export default {
  name: "board",
  data(){
    return{
      tableData: [],
      total:10,
      pageSize:10,
      current:1,
      tableHeight:300,
      isShow:false,
      msg:"",
      form:{
        name:"",
        idCard:""
      },
      index:"1",
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ],
      }
    }
  },
  created() {
    // this.index="1";
    this.getDataList();
  },
  methods: {
    //获取数据
    getDataList(){
      let httpURL = `/dismiss/show_list`; //目标地址后接的详细地址
      let formData = new FormData();
      formData.append('pageSize', this.pageSize);
      formData.append('pageNum', this.current);
      let that=this;
      request.post(httpURL,formData).then(function (res) {
        // console.log(res);
        if (res.code == "0") {
          // console.log(res);
          // that.tableData=res.rows;
          let resData=res.rows;
          for(let i=0;i<resData.length;i++){
            resData[i].dismissTime=(resData[i].dismissTime).substring(0,10);
          }
          that.tableData=resData;
          that.total=res.total;
        }
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.current = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.current = val
      this.getDataList()
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if(key=="2"){
        this.$router.push({ name:'WebSupplierBoard'})
      }
    },
    handleSearch(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // console.log(this.form)
          let httpURL = `/dismiss/find_staff`; //目标地址后接的详细地址
          let data=this.form;
          let that=this;
          // this.isShow=true;
          request.post(httpURL, data).then(function (res) {
            // console.log(res);
            if (res.code == "0") {

              that.isShow=true;
              that.msg=res.msg;
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.back{    /* div的CSS样式 */
  position : absolute;
  top:0;
  left: 0;
  width : 100%;
  height :100%;
  /*background: url("static/png/back.jpg");*/
  /*background-image: url("../png/back.jpg");*/
  /*background-size:100% 100%;*/
}

.header{
  width: 100%;
  height: 15vh;
  background: white;
  border-bottom: 1px solid gainsboro;
}

.tableHead{
  background:#409EFF;
  color:#ffffff;
  border: 1px solid tan;
  size:25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/board.vue